import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/example/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello! /admin/example/</div>
}